import { useStackContext } from '@app/packages/StackContext/StackContext'
import type { PromiseState } from '@app/packages/thunkSelector/promiseState'

export const usePromiseState = (promise: PromiseState) => {
  const stackContext = useStackContext()
  if (!promise.resolved.value) throw stackContext.suspend(promise.promise())
  if (promise.error.value) throw promise.error.value
}
